import { useFormContext } from 'react-hook-form';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { useCurrentRateGroupContext, useCurrentServiceIdContext } from '../contexts';
import { PolicyExceptionFormValues } from '../schemas';

export const useGetCollidingRates = (policyOverrideId?: string) => {
    const serviceId = useCurrentServiceIdContext();
    const { id: rateGroupId } = useCurrentRateGroupContext();

    const { watch } = useFormContext<PolicyExceptionFormValues>();
    const timeUnitIntervals: PolicyExceptionFormValues['dates']['timeUnitIntervals'] = watch('dates.timeUnitIntervals');

    return useRepositoryQuery(
        'paymentAndCancellationPolicies',
        'validate',
        {
            policyOverrideId,
            rateGroupId,
            serviceId,
            timeUnitIntervals,
        },
        {
            staleTime: 5000,
            select: (data) =>
                data.collidingRateIds.reduce((collidingRates: Record<string, true>, rateId: string) => {
                    collidingRates[rateId] = true;
                    return collidingRates;
                }, {}),
        }
    );
};
